module.exports = __WEBPACK_EXTERNAL_MODULE_212__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Subject"
// module id = 212
// module chunks = 0